// Labor bucket display names and colors
// Keyed by both snake_case enum values (legacy) and dynamic BOM API names
export const laborBucketConfig: Record<string, { label: string; color: string }> = {
  // Legacy snake_case keys (from seed data / hardcoded enums)
  mechanical_engineering: { label: 'Mechanical Eng', color: 'bg-blue-500' },
  electrical_engineering: { label: 'Electrical Eng', color: 'bg-indigo-500' },
  software_design: { label: 'Software Design', color: 'bg-purple-500' },
  image_formation_design: { label: 'Image Formation', color: 'bg-pink-500' },
  software_development: { label: 'Software Dev', color: 'bg-violet-500' },
  fabrication: { label: 'Fabrication', color: 'bg-orange-500' },
  electrical_assembly: { label: 'Electrical Assy', color: 'bg-amber-500' },
  final_assembly: { label: 'Final Assembly', color: 'bg-yellow-500' },
  testing_qc: { label: 'Testing/QC', color: 'bg-green-500' },
  packing_shipping: { label: 'Packing/Ship', color: 'bg-teal-500' },
  procuring: { label: 'Procuring', color: 'bg-cyan-500' },
  waiting_for_parts: { label: 'Waiting Parts', color: 'bg-gray-400' },
  awaiting_confirmation: { label: 'Confirm', color: 'bg-yellow-400' },
  awaiting_shipment: { label: 'Shipment', color: 'bg-yellow-300' },
  awaiting_receipt: { label: 'Receipt', color: 'bg-yellow-200' },
  stage_parts: { label: 'Stage Parts', color: 'bg-lime-500' },
  supply_chain_release: { label: 'Supply Chain', color: 'bg-emerald-500' },

  // Dynamic BOM API labor category names (human-readable)
  'Mechanical Engineering': { label: 'Mechanical Eng', color: 'bg-blue-500' },
  'Electrical Engineering': { label: 'Electrical Eng', color: 'bg-indigo-500' },
  'Software Engineering/Development': { label: 'Software Dev', color: 'bg-violet-500' },
  'Fabrication': { label: 'Fabrication', color: 'bg-orange-500' },
  'Electrical Assembly': { label: 'Electrical Assy', color: 'bg-amber-500' },
  'Mechanical Assembly/Final Assembly': { label: 'Final Assembly', color: 'bg-yellow-500' },
  'Testing and QC': { label: 'Testing/QC', color: 'bg-green-500' },
  'Crating, Packing, Labeling, Freight': { label: 'Packing/Ship', color: 'bg-teal-500' },
};
